import React, { useState } from "react";
import {
  TableRow,
  TableCell,
  Checkbox,
  TextField,
  Button,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { updateAdminDeviceId } from "../actions/auth";

const AdminRow = ({openSnackbar}) => {
    const [newDeviceId, setNewDeviceId] = useState("");
  const [deviceId, setDeviceId] = useState([]);
  const user = JSON.parse(localStorage.getItem("profile"));
  const dispatch = useDispatch();
  const handleChange = (e) => {
    const value = e.target.value;
    setNewDeviceId(value); // Store the current input in a temporary variable
  };


  // const updateDeviceId = async () => {
  //   const deviceId = 'eM86hOgQRwuhvQw-xR48G4:APA91bEozxsU6Oia9Nn90AcCSIh5lkQXYFViVTZodw-tLqzybHRnaWRG2BwpELpJ2PV5yZL2HOv_4i10sZBVfpZvKaq3S9RmU5zGqOpVe3GgMH3kIgfxY3i1LWH25e85Rp_5gzhiIdHy'; // Replace with the new device ID
  //   const email = 'admin@admin.com'; // Replace with the username
  //   const password = 'admin'; // Replace with the password
  //   const form={
  //     deviceId,
  //     email,
  //     password
  //   }
  //   dispatch(updateAdminDeviceId(form,openSnackbar));
     
  // };
  

  


  const handleSubmit = (e) => {
    e.preventDefault();
    if (newDeviceId.trim() !== "") {
      // Check if the input is not empty before adding it
      setDeviceId([...deviceId, newDeviceId]); // Update the state with the new input
    }
    setNewDeviceId(""); // Reset the temporary variable to clear the input field
    // Dispatch action or perform other tasks
     dispatch(updateAdminDeviceId(user.result._id, { deviceId: [...deviceId, newDeviceId] },openSnackbar));
    
    setDeviceId([]);
    // Reload the page (optional)
  };


  return (
    <div style={{ display: "flex" }}>
      <TextField
        label="Device Id"
        type="text"
        value={newDeviceId}
        id="outlined-size-small"
        onChange={handleChange}
        variant="outlined"
        size="small"
      />
      <Button onClick={handleSubmit} style={{color:"white",backgroundColor:"#ef7f1a",height:"2rem",margin:"5px"}} >
        Add
      </Button>
      {/* <Button onClick={updateDeviceId} style={{color:"white",backgroundColor:"Black",height:"2rem"}}>
        HIT
      </Button> */}
    </div>
  );
};

export default AdminRow;
